import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Hidden,
  Box,
  Switch,
  FormGroup,
  FormControlLabel,
  IconButton,
  Dialog,
  DialogContent,
  DialogContentText,
  TextField,
  MenuItem,
  Autocomplete,
  DialogActions,
  Button,
  Tooltip,
  DialogTitle,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useGlobalState } from "../../context/global-state-context";
import MessageBox from "../shared/components/MessageBox";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { DateTextField, SearchTextField } from "../lib";
import { FilterList } from "@mui/icons-material";

function ToDosAdmin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [aufgaben, setAufgaben] = useState([]);
  const [filteredAufgaben, setFilteredAufgaben] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [globalState, setGlobalState] = useGlobalState();
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const aufgaben_key = useRef("");
  const aufgaben_bez = useRef("");
  const aufgaben_art = useRef("");
  const aufgaben_fragen = useRef([]);
  const [filteraufgaben, setFilterAufgaben] = useState(globalState.webagu_aufgaben);
  const [filtererinnerungen, setFilterErinnerungen] = useState(globalState.webagu_erinnerung);
  const [filternuaktive, setFilterNurAktive] = useState(globalState.webagu_nuraktiv);
  const [msgbox, setMsgBox] = useState(false);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [formValues, setFormValues] = useState({
    key: "",
    mitarbeiterwahl: "",
    BezKurz: "",
    BezLang: "",
    Minuten: "30",
    Termin: "",
  });

  // Filter
  const [aktionenFilterOptionen, setAktionenFilterOptionen] = useState([]);
  const storedFilterObject = JSON.parse(localStorage.getItem("WEBAGU_FILTER_OFFENE"));
  const [filter, setFilter] = useState(storedFilterObject?.filter ? storedFilterObject?.filter : "O");
  const [suche, setSuche] = useState(storedFilterObject?.suche ? storedFilterObject?.suche : "");
  const [datumsFilter, setDatumsFilter] = useState(storedFilterObject?.datumsFilter ? storedFilterObject?.datumsFilter : "");
  const [aufgabenartFilter, setAufgabenartFilter] = useState(storedFilterObject?.aufgabenartFilter ? storedFilterObject?.aufgabenartFilter : []);
  const [mandantFilter, setMandantFilter] = useState(storedFilterObject?.mandantFilter ? storedFilterObject?.mandantFilter : []);
  const [filterDialog, setFilterDialog] = useState(false);

  const mandantFilterOptions = useMemo(() => {
    // Herrausfiltern der einzelnen Optionen
    const tmpfilter = aufgaben
      ?.filter((value, index, array) => array.findIndex((element) => element.mandant === value.mandant) === index)
      .map((mapElement) => ({
        value: mapElement.mandant,
        label: mapElement.mandant,
        color: mapElement.color,
      }));
    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [aufgaben]);

  const aufgabenArtFilterOptions = useMemo(() => {
    // Herrausfiltern der einzelnen Optionen
    const tmpfilter = aktionenFilterOptionen
      ?.filter((value, index, array) => array.findIndex((element) => element.key === value.key) === index)
      .map((mapElement) => {
        return {
          value: mapElement.key,
          label: mapElement.bezeichnung,
          color: mapElement.color,
        };
      })
      ?.filter((item) => item !== null);
    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [aktionenFilterOptionen, filter]);

  useEffect(() => {
    hole_aufgaben();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Die Änderung des filters einmal in localstorage schreiben
    const filterObject = {
      filter: filter,
      mandantFilter: mandantFilter,
      aufgabenartFilter: aufgabenartFilter,
      datumsFilter: datumsFilter,
      suche: suche,
    };
    localStorage.setItem("WEBAGU_FILTER_OFFENE", JSON.stringify(filterObject));

    // Hier die Aufgaben filtern
    const result = aufgaben?.filter((item) => {
      const tmpMandant = mandantFilter?.length !== 0 ? mandantFilter.some((searchItem) => searchItem.value === item.mandant) : true;
      const tmpAufgaben = aufgabenartFilter?.length !== 0 ? aufgabenartFilter.some((searchItem) => searchItem.value === item.aktion) : true;
      const tmpSuche =
        suche?.trim() !== ""
          ? [item.bezeichnung, item.ersteller, item.betreff, item.betroffener, item.datum, item.art].some((field) =>
              field?.toLowerCase().includes(suche.toLowerCase())
            )
          : true;

      // Datumsfilter etwas unübersichtlich: prüt ob datum <= eingestelltem Datum ist. Zusätzlich geben wir keine Aufgaben ohne first zurück. Soll nur die Aufgaben zeigen welche zu dem Termin erledigt sein müssen
      const datumEingestellt =
        datumsFilter?.trim() !== ""
          ? [item.datumFormular].some((field) => {
              if (field === "") return false;
              return field.replace(/-/g, "") <= datumsFilter.replace(/-/g, "");
            })
          : true;

      return tmpMandant && tmpAufgaben && tmpSuche && datumEingestellt;
    });

    setFilteredAufgaben(result);
  }, [aufgaben, filter, mandantFilter, aufgabenartFilter, datumsFilter, suche]);

  const hole_aufgaben = () => {
    setIsLoading(true);
    const payload = {
      statement: "ERSTELLTE_AUFGABEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "aufgaben", payload, headers, datenCb, errorCb);
  };

  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  };

  const datenCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setAktionenFilterOptionen(response.data.aktionenFilter);
      setAufgaben(response.data.aufgaben);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const loeschen = () => {
    setIsLoading(true);
    const payload = {
      statement: "AUFGABE_LOESCHEN_NEU",
      aufgabe: aufgaben_key.current,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "aufgaben", payload, headers, loeschenCb, errorCb);
  };

  const loeschenCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setEditDialogOpen(false);
      hole_aufgaben();
      showSuccessMessage("Aufgabe erfolgreich gelöscht");
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const messageBoxResult = (result) => {
    if (result === "YES") {
      loeschen();
    }
    setMsgBox(false);
  };

  if (msgbox) {
    return (
      <MessageBox
        open={msgbox}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={'Soll die Aufgabe "' + aufgaben_bez.current + '" wirklich gelöscht werden?"'}
        title={t("Löschbestätigung")}
        onClose={() => setMsgBox(false)}
      />
    );
  }

  const handleAufgabenEdit = () => {
    setIsLoading(true);
    const payload = {
      statement: "AUFGABE_BEARBEITEN",
      formData: formValues,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "aufgaben", payload, headers, editCb, errorCb);
  };

  const editCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setEditDialogOpen(false);
      hole_aufgaben();
      showSuccessMessage("Aufgabe erfolgreich editiert");
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const handleChange = (event, newValue, newName) => {
    const { name, value } = event.target;

    if (name) {
      setFormValues({ ...formValues, [name]: value });
    } else if (newValue?.key) {
      setFormValues({ ...formValues, [newName]: newValue?.key });
    }
  };

  if (isLoading) {
    return (
      <Layout>
        <LoadingComponent />
      </Layout>
    );
  }

  const bearbeiten = (event, element, art) => {
    setFormValues({
      key: element.key,
      BezKurz: element.bezeichnung,
      BezLang: element.bez_lang,
      Minuten: element.aw_ist,
      Termin: element.datumFormular,
    });

    aufgaben_key.current = element.key;
    aufgaben_bez.current = element.bezeichnung;
    aufgaben_art.current = element.art;
    aufgaben_fragen.current = element.fragen;
    event.stopPropagation();
    if (art === "edit") {
      setEditDialogOpen(true);
    }
    if (art === "loeschen") {
      setMsgBox(true);
    }
  };

  const aufgaben_zeichnen =
    filteredAufgaben?.length > 0 ? (
      filteredAufgaben.map((element, index) => {
        if (!filteraufgaben && element.art === "Aufgabe") {
          return null;
        }
        if (!filtererinnerungen && element.art === "Erinnerung") {
          return null;
        }
        if (!filteraufgaben && element.art === "Aufgabe") {
          return null;
        }
        if (filternuaktive && element.inaktiv) {
          return null;
        }
        return (
          <Fragment>
            <Hidden smDown>
              <TableRow key={index} onClick={() => navigate("/WEBAGU/aufgabe/" + element.key)} style={{ cursor: "pointer" }} hover>
                <TableCell>{element.art}</TableCell>
                <TableCell>{element.ersteller}</TableCell>
                <TableCell>{element.bezeichnung}</TableCell>
                <TableCell>{element.datum}</TableCell>
                <TableCell>{element.mandant_vkey}</TableCell>
                <TableCell>{element.betroffener}</TableCell>
                <TableCell>
                  <IconButton variant="contained" color="primary" onClick={(event) => bearbeiten(event, element, "edit")}>
                    {" "}
                    <EditIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <IconButton variant="contained" color="primary" onClick={(event) => bearbeiten(event, element, "loeschen")}>
                    {" "}
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            </Hidden>
            <Hidden smUp>
              <TableRow key={index} onClick={() => navigate("/WEBAGU/aufgabe/" + element.key)}>
                <TableCell>
                  <Typography>{element.art}</Typography>
                  <Typography>{element.ersteller}</Typography>
                  <Typography>{element.bezeichnung}</Typography>
                  <Typography>{element.datum}</Typography>
                  <Typography>{element.mandant_vkey}</Typography>
                  <Typography>{element.betroffener}</Typography>
                  <IconButton variant="contained" color="primary" onClick={(event) => bearbeiten(event, element, "edit")}>
                    {" "}
                    <EditIcon />
                  </IconButton>
                  <IconButton variant="contained" color="primary" onClick={(event) => bearbeiten(event, element, "loeschen")}>
                    {" "}
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            </Hidden>
          </Fragment>
        );
      })
    ) : (
      <TableRow>
        <TableCell colSpan="8">
          <Typography>{t("Es wurden keine Aufgaben gefunden")}</Typography>
        </TableCell>
      </TableRow>
    );

  return (
      <Layout>
        <Dialog open={editDialogOpen} maxWidth="md" onClose={() => setEditDialogOpen(false)} fullWidth>
          <DialogContent sx={{ height: "96" }}>
            <DialogContentText style={{ fontSize: 22, fontWeight: "bold" }}>Aufgabe bearbeiten</DialogContentText>
            <form onSubmit={handleAufgabenEdit} id="aufgaben-form">
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <Grid item sm={12}>
                    <Box p={1}>
                      <TextField
                        variant="outlined"
                        label={t("Aufgabenbezeichnung")}
                        value={formValues.BezKurz}
                        onChange={handleChange}
                        id="BezKurz"
                        name="BezKurz"
                        fullWidth
                        required
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item sm={12}>
                    <Box p={1}>
                      <TextField
                        variant="outlined"
                        type="number"
                        label={t("Wie lange dauert die Aufgabe in Min (etwa)")}
                        value={formValues.Minuten}
                        onChange={handleChange}
                        id="Minuten"
                        name="Minuten"
                        fullWidth
                        required
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item sm={12}>
                    <Box p={1}>
                      <TextField
                        multiline
                        rows={3}
                        variant="outlined"
                        label={t("Beschreibung")}
                        value={formValues.BezLang}
                        onChange={handleChange}
                        id="BezLang"
                        name="BezLang"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item sm={12}>
                    <Box p={1}>
                      <DateTextField
                        variant="outlined"
                        label={t("Bis wann soll die Aufgabe erledigt werden?")}
                        value={formValues.Termin}
                        onChange={handleChange}
                        id="Termin"
                        name="Termin"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button style={{ marginRight: "10px" }} display="flex" onClick={() => setEditDialogOpen(false)}>
              {t("Abbrechen")}
            </Button>
            <Button color="primary" variant="contained" type="submit" form="aufgaben-form">
              {t("Speichern")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Desktop Filter*/}
        <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
          <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
            <Grid item xs={12} md={3}>
              <SearchTextField
                size="small"
                fullWidth
                label={t("Suche")}
                id="filter"
                variant="outlined"
                value={suche}
                inputProps={{
                  autoCapitalize: "off",
                  autoCorrect: "off",
                  spellCheck: "false",
                  autoComplete: "off",
                }}
                onChange={(e) => setSuche(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Aufgaben anzeigen, die bis zum [Datum] erledigt sein müssen"
                value={datumsFilter}
                onChange={(e) => setDatumsFilter(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                onChange={(event, newValue) => {
                  setMandantFilter(newValue);
                }}
                value={mandantFilter}
                size="small"
                id="tags-outlined"
                options={mandantFilterOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} label="Nach Mandant filtern" placeholder="Mandant" />}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                multiple
                onChange={(event, newValue) => {
                  setAufgabenartFilter(newValue);
                }}
                value={aufgabenartFilter}
                size="small"
                id="tags-outlined"
                options={aufgabenArtFilterOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} label="Nach Aufgabenart filtern" placeholder="Aufgabenart" />}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Mobile Filter*/}
        <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
          <Box display="flex" alignItems={"center"}>
            <SearchTextField
              size="small"
              fullWidth
              label={t("Suche")}
              id="filter"
              variant="outlined"
              value={suche}
              inputProps={{
                autoCapitalize: "off",
                autoCorrect: "off",
                spellCheck: "false",
                autoComplete: "off",
              }}
              onChange={(e) => setSuche(e.target.value)}
            />

            <Box pr={1}>
              <Tooltip title="Filter">
                <IconButton color="primary" onClick={() => setFilterDialog(true)}>
                  <FilterList />
                </IconButton>
              </Tooltip>
            </Box>

            <Dialog open={filterDialog} onClose={() => setFilterDialog(false)} maxWidth="md" fullWidth>
              <DialogTitle>Filter</DialogTitle>
              <DialogContent>
                <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
                  <Grid item xs={12} md={5}></Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      type="date"
                      label="Aufgaben anzeigen, die bis zum [Datum] erledigt sein müssen"
                      value={datumsFilter}
                      onChange={(e) => setDatumsFilter(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setMandantFilter(newValue);
                      }}
                      value={mandantFilter}
                      size="small"
                      id="tags-outlined"
                      options={mandantFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Nach Mandant filtern" placeholder="Mandant" />}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setAufgabenartFilter(newValue);
                      }}
                      value={aufgabenartFilter}
                      size="small"
                      id="tags-outlined"
                      options={aufgabenArtFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Nach Aufgabenart filtern" placeholder="Aufgabenart" />}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button style={{ marginRight: "10px" }} variant="secondary" display="flex" onClick={() => setFilterDialog(false)}>
                  {t("Abbrechen")}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>

        <>
          {/* Mobile */}
          <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
            <TableContainer sx={{ maxHeight: window.innerHeight - 250 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{aufgaben_zeichnen}</TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Desktop */}
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
            <TableContainer sx={{ maxHeight: 950 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Art")}</TableCell>
                    <TableCell>{t("Eingestellt von")}</TableCell>
                    <TableCell>{t("Bezeichnung")}</TableCell>
                    <TableCell>{t("Fällig bis")}</TableCell>
                    <TableCell>{t("Mandant")}</TableCell>
                    <TableCell>{t("zu erledigen von")}</TableCell>
                    <TableCell>{t("Bearbeiten")}</TableCell>
                    <TableCell>{t("Löschen")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{aufgaben_zeichnen}</TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      </Layout>
  );
}
export default ToDosAdmin;
